

 <div class="stepper-container">
 
    <mat-stepper  style="align-items: center;" [linear]="true" #stepper>
      <mat-step class="layout-container" style="height: 100%;max-width: 929px;"  [stepControl]="firstStep">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
       
        </ng-template>
        <div >
        <form [formGroup]="firstStep">
          <ng-template matStepLabel>Signatures</ng-template>
  <div class="stepper-container-step-1 ">


    <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Electronic Communications and Signatures Consent</div>
  <div class="stepper-text">
   By proceeding with this online application process, you understand and agree that the County Tax Collector’s Office (“Tax Collector”) may communicate with you regarding this application or other Tourist Tax matters electronically, both now and in the future. You further consent and agree that by doing so we may choose to provide such communications or other documents in electronic format only, through our online system or to the email address provided to the Tax Collector by you. Moreover, unless and until such consent is withdrawn, you agree that applications, agreements, notices, and other documents provided or made available to you may be executed electronically and that such electronic signatures shall bedeemed to have the same legal effect as if such were signed in wet ink in accordance with the Electronic Signatures in Global and National Commerce Act (“E-Sign Act”), Title 15, United States Code, Sections 7001 et seq., and the Uniform Electronic Transaction Act (“UETA”), as the same has been implemented in the State of Florida. In order to ensure proper and timely delivery of communications and other documents and information, it is your responsibility to ensure that the Tax Collector has a valid email address for you at all times. You further acknowledge that by consenting to electronic delivery, you have the ability to retain such communications and other documents. Should you fail to updateor change incorrect information or an invalid email address or other contact information, you understand and agree that nevertheless any communications, documents, or other information provided to you via the email address the Tax Collector has been provided will be deemed to have been delivered to you.
 
   <div class="stepper-container-row-item">
    <mat-checkbox  color="primary" class="primary">
      I understand and acknowledge the reminders posted above
    </mat-checkbox> 
   </div>
   <div class="stepper-container-row-item">

    <mat-form-field class="mat-form-field-70"  appearance="outline">
      <mat-label>Printed Name / eSignature</mat-label>
      <input id="printedName" formControlName="printedName" [(ngModel)]="model.printedName" matInput placeholder="Printed Name">
    </mat-form-field>
  
</div>
<div class="stepper-container-row-item" *ngIf="this.firstStep.get('printedName')?.errors?.['required'] && (firstStep.get('printedName')?.touched)">
  <mat-error>Printed Name is required</mat-error>
</div>
<div class="stepper-container-row-item" *ngIf="this.firstStep.get('printedName')?.errors?.['maxLength'] && (firstStep.get('printedName')?.touched)">
  <mat-error>Max Length is 400</mat-error>

</div>
<div class="stepper-container-row-item">
  <br />
<div style="color: rgba(0, 0, 0, 0.60); font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 24px; letter-spacing: 0.15px; word-wrap: break-word"><mat-icon>info_outline</mat-icon> If you have any additional questions, please contact the Tourist Tax Department at {{ (branding$ | async)?.phone }}</div>
</div>       
  </div>
         

     
         

      </div>
         <footer class="footer-step">
          
         <div style="width: 70%; justify-content: space-around;">
     
          <div style="width: 100%;
          padding-top: 16px;
          padding-bottom: 16px;
          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
            <button (click)="openDialog()" mat-stroked-button  class="button-cancel">
              CANCEL
              <mat-icon>close</mat-icon>
           </button>
           <button [disabled]="!firstStep.valid" matStepperNext mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': firstStep.valid ,'button-stepper': firstStep.invalid  }">
            NEXT
            <mat-icon>arrow_right_alt</mat-icon>
            
         </button>
          </div>
         </div>
        </footer>
        </form>
      </div>
      </mat-step>
      <mat-step [stepControl]="selectUserType">
        <form [formGroup]="selectUserType">
          <ng-template matStepLabel>User Type</ng-template>
          <mat-radio-group formControlName="userType"  aria-label="Select an option">
            <div class="row" style="justify-content: center;">
              <p style="font-size: 24px; font-weight: normal;">Select User type</p>
            </div>
             
        <div class="row">
          <div  [ngClass]="{'column': registerAs != '4' ,'column-card': registerAs != '1' ,'column-card-selected': registerAs == '1'   }">
    <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
      <div style="align-self: stretch; height: 84px; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <div [ngClass]="{'column-card-title-blue': registerAs != '1' ,'column-card-title-white': registerAs == '1'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon >person</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Individual property owner</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button (change)="radioChange($event)" color="primary" value="1">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">You are the property owner and want to create an account to validate tax info or manage taxes by yourself.</div>
      </div>
    </div>
  </div>
  <div  [ngClass]="{'column': registerAs != '4' ,'column-card': registerAs != '2' ,'column-card-selected': registerAs == '2'   }">
    <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
      <div style="align-self: stretch; height: 84px; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <div [ngClass]="{'column-card-title-blue': registerAs != '2' ,'column-card-title-white': registerAs == '2'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon >location_city</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Property management company</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button (change)="radioChange($event)" color="primary" value="2">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">This category is suitable for companies responsible for maintaining properties, collecting rent, and handling tenant relations on behalf of property owners.</div>
      </div>
    </div>
  </div>
  <div  [ngClass]="{'column': registerAs != '4' ,'column-card': registerAs != '3' ,'column-card-selected': registerAs == '3'   }">
    <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
      <div style="align-self: stretch; height: 84px; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <div [ngClass]="{'column-card-title-blue': registerAs != '3' ,'column-card-title-white': registerAs == '3'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon>hotel</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch; font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Bed & breakfast / Hotel / Motel</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button  (change)="radioChange($event)" color="primary" value="3">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">Select this option if you  that provides lodging services. This category is ideal for businesses offering short-term accommodations.</div>
      </div>
    </div>
  </div>
        </div>
     
        </mat-radio-group>
        <br />
        <footer class="footer-step">
        <div  class="row" style="width: 70%;">
  
          <div style="width: 100%;
          padding-top: 16px;
          padding-bottom: 16px;
          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
           <button mat-stroked-button mat-button class="button-cancel">
              CANCEL
              <mat-icon>close</mat-icon>
           </button>
           <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
            BACK
            <mat-icon>arrow_left_alt</mat-icon>
         </button>
           <button [disabled]="!selectUserType.valid" matStepperNext mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': selectUserType.valid ,'button-stepper': selectUserType.invalid  }">
            NEXT
            <mat-icon>arrow_right_alt</mat-icon>
            
         </button>
          </div>
         </div>
         </footer>
        </form>
      </mat-step>
      <mat-step [stepControl]="getFormGroup()"  label="Owner">
        <ng-template matCardImageLarge matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
       
        </ng-template>
      
        <form *ngIf="registerAs == '1'" [formGroup]="secondStepForm">
          
          <div class="row" style="justify-content: center;">
            <label class="label-icon">
              <mat-icon>person</mat-icon>
              <span>INDIVIDUAL PROPERTY OWNER</span>
          </label>
          </div>
          <ng-template matStepLabel>Main Info</ng-template>
     
    <div class="form-center-ho">
      <div class="row"  style="justify-content: center; padding-bottom: 32px; margin-top: 32px;">
        <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Main info</div>
      </div>

    

              <mat-form-field class="mat-form-field-50" appearance="outline">
                <mat-label style="font-size: 16px !important;">First Name</mat-label>
                <input matInput formControlName="firstName" placeholder="First Name"
                       required>
                      </mat-form-field>
                      <div *ngIf="this.secondStepForm.get('firstName')?.errors?.['required'] && (secondStepForm.get('firstName')?.touched)">
                        <mat-error>First Name is required</mat-error>
                      </div>
                      <br />
              <mat-form-field class="mat-form-field-50" appearance="outline" >
                <mat-label style="font-size: 16px !important;">Last Name</mat-label>
                <input matInput formControlName="lastName" placeholder="Last Name"
                       >
              </mat-form-field>
              <div *ngIf="this.secondStepForm.get('lastName')?.errors?.['required'] && (secondStepForm.get('lastName')?.touched)">
                <mat-error>Last Name is required</mat-error>
              </div>
          <br />
          <mat-form-field  class="mat-form-field-50" appearance="outline">
            <mat-label style="font-size: 16px !important;">Email Address</mat-label>
            <input required matInput formControlName="email" placeholder="Email Address"
                   >
          </mat-form-field>
          <div *ngIf="this.secondStepForm.get('email')?.errors?.['required'] && (secondStepForm.get('email')?.touched)">
            <mat-error>Email Address is required</mat-error>
          </div>
  
          <div *ngIf="this.secondStepForm.get('email')?.errors?.['email'] && (secondStepForm.get('email')?.touched && secondStepForm.get('email')?.value)">
            <mat-error>Email Address is Invalid</mat-error>
          </div> 
          <br />
          <mat-form-field  class="mat-form-field-50" appearance="outline" >
            <mat-label style="font-size: 16px !important;">Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Phone Number"
                   >
          </mat-form-field>
  
          <div *ngIf="this.secondStepForm.get('phoneNumber')?.errors?.['required'] && (secondStepForm.get('phoneNumber')?.touched)">
            <mat-error>Phone Number is required</mat-error>
          </div>
  
          <div *ngIf="this.secondStepForm.get('phoneNumber')?.errors?.['pattern'] && (secondStepForm.get('phoneNumber')?.touched && secondStepForm.get('phoneNumber')?.value)">
            <mat-error>Phone Number is Invalid</mat-error>
          </div>
        </div>
          <footer class="footer-step">
            <div  class="row" style="width: 70%;">
  
              <div style="width: 100%;
              padding-top: 16px;
              padding-bottom: 16px;
              box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                 <button mat-stroked-button mat-button class="button-cancel">
                CANCEL
                <mat-icon>close</mat-icon>
             </button>
             <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
              BACK
              <mat-icon>arrow_left_alt</mat-icon>
           </button>
             <button [disabled]="!secondStepForm.valid" matStepperNext mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': secondStepForm.valid ,'button-stepper': secondStepForm.invalid  }">
              NEXT
              <mat-icon>arrow_right_alt</mat-icon>
              
           </button>
            </div>
           </div>
           </footer>
        </form>
        <form *ngIf="registerAs == '2'" [formGroup]="managementCompany">
          <div class="row" style="justify-content: center;">
            <label class="label-icon">
              <mat-icon>business</mat-icon>
              <span>PROPERTY MANAGEMENT COMPANY</span>
          </label>
        </div>
          <ng-template matStepLabel>Main Info</ng-template>
    
              <div class="form-center-ho">
                <div class="row"  style="justify-content: center; padding-bottom: 32px; margin-top: 32px;">
                  <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Main info</div>
                </div>
          
              <div class="row"  style="justify-content: center;">
       
              <mat-form-field class="mat-form-field-50" appearance="outline">
                <mat-label>Business Legal name</mat-label>
                <input  matInput formControlName="businessLegalName" placeholder="Business Legal name"
                       required>
                      </mat-form-field>
                      <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('businessLegalName')?.errors?.['required'] && (managementCompany.get('businessLegalName')?.touched)">
                        <mat-error>Business Legal name is required</mat-error>
                      </div>
                    </div>
                    <div class="row"  style="justify-content: center;" style="justify-content: center;"> 
              <mat-form-field class="mat-form-field-50" appearance="outline" >
                <mat-label>Business DBA name</mat-label>
                <input matInput formControlName="businessDBAname" placeholder="Business DBA name"
                       >
              </mat-form-field>
                    </div>
                    <div class="row" style="justify-content: center;"> 
          <mat-form-field class="mat-form-field-50" appearance="outline">
            <mat-label>Primary Contact First Name</mat-label>
            <input matInput formControlName="primaryContactFirstName" placeholder="Primary Contact First Name"
                   required>
                  </mat-form-field>
                  <div *ngIf="this.managementCompany.get('primaryContactFirstName')?.errors?.['required'] && (managementCompany.get('primaryContactFirstName')?.touched)">
                    <mat-error>Primary Contact First Name is required</mat-error>
                  </div>
                </div>
                <div class="row" style="justify-content: center;"> 
          <mat-form-field class="mat-form-field-50" appearance="outline" >
            <mat-label>Primary Contact Last Name</mat-label>
            <input matInput formControlName="primaryContactLastName" placeholder="Primary Contact Last Name"
                   >
          </mat-form-field>
          <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('primaryContactLastName')?.errors?.['required'] && (managementCompany.get('primaryContactLastName')?.touched)">
            <mat-error>Primary Contact Last Name is required</mat-error>
          </div>
        </div>
        <div class="row" style="justify-content: center;"> 
          <mat-form-field  class="mat-form-field-50" appearance="outline">
            <mat-label>Primary Contact Email Address</mat-label>
            <input required matInput formControlName="primaryContactEmail" placeholder="Email Address"
                   >
          </mat-form-field>
          <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('primaryContactEmail')?.errors?.['required'] && (managementCompany.get('primaryContactEmail')?.touched)">
            <mat-error>Primary Contact Email Address is required</mat-error>
          </div>
  
          <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('primaryContactEmail')?.errors?.['email'] && (managementCompany.get('primaryContactEmail')?.touched && managementCompany.get('primaryContactEmail')?.value)">
            <mat-error>Primary Contact Email Address is Invalid</mat-error>
          </div> 
       </div>
       <div class="row" style="justify-content: center;"> 
          <mat-form-field  class="mat-form-field-50" appearance="outline" >
            <mat-label>Primary Contact Phone Number</mat-label>
            <input matInput formControlName="primaryContactPhoneNumber" placeholder="Primary Contact Phone Number"
                   >
          </mat-form-field>
  
          <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('primaryContactPhoneNumber')?.errors?.['required'] && (managementCompany.get('primaryContactPhoneNumber')?.touched)">
            <mat-error>Primary Contact Phone Number is required</mat-error>
          </div>
  
          <div class="row"  style="justify-content: center;" *ngIf="this.managementCompany.get('primaryContactPhoneNumber')?.errors?.['pattern'] && (managementCompany.get('primaryContactPhoneNumber')?.touched && managementCompany.get('primaryContactPhoneNumber')?.value)">
            <mat-error>Primary Contact Phone Number is Invalid</mat-error>
          </div>
        </div>
            
        
      </div>
          <footer class="footer-step">
            <div  class="row" style="width: 59%;">
  
              <div style="width: 100%;
              padding-top: 16px;
              padding-bottom: 16px;
              box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                <button mat-stroked-button mat-button class="button-cancel">
                CANCEL
                <mat-icon>close</mat-icon>
             </button>
             <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
              BACK
              <mat-icon>arrow_left_alt</mat-icon>
           </button>
             <button [disabled]="!managementCompany.valid" matStepperNext mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': managementCompany.valid ,'button-stepper': managementCompany.invalid  }">
              NEXT
              <mat-icon>arrow_right_alt</mat-icon>
              
           </button>
            </div>
           </div>
         
           </footer>
         
        </form>
        <form *ngIf="registerAs == '3'" [formGroup]="hotelMotel">
          <div class="row" style="justify-content: center;">
            <label class="label-icon">
              <p> <mat-icon style="color: #2196F3;">hotel</mat-icon></p>
              <span>BED & BREAKFAST/ HOTEL / MOTEL</span>
          </label>
           
          </div>
          <ng-template matStepLabel>Main Info</ng-template> 
       
          <div class="form-center-ho">
            <div class="row"  style="justify-content: center; padding-bottom: 32px; margin-top: 32px;">
              <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Main info</div>
            </div>
             
              <div class="row-no-flex "  style="justify-content: center;">
              <mat-radio-group class="primary" aria-label="Select an option">
                <mat-radio-button  value="1"></mat-radio-button> 
                <mat-form-field class="mat-form-field-50" appearance="outline">
                  <mat-label>First name / Last name</mat-label>
                  <input matInput formControlName="personNameOrCompanyName" placeholder="First name / Last name"
                         required>
                        </mat-form-field>
                        <div *ngIf="this.hotelMotel.get('personNameOrCompanyName')?.errors?.['required'] && (hotelMotel.get('businessLegalName')?.touched)">
                          <mat-error>Name is required</mat-error>
                        </div>
                   OR
                <mat-radio-button class="primary" value="2"></mat-radio-button>
                <mat-form-field class="mat-form-field-50" appearance="outline">
                  <mat-label>Company name</mat-label>
                  <input matInput formControlName="personNameOrCompanyName" placeholder="Company Name"
                         required>
                        </mat-form-field>
                        <div *ngIf="this.hotelMotel.get('personNameOrCompanyName')?.errors?.['required'] && (hotelMotel.get('businessLegalName')?.touched)">
                          <mat-error>Company Name is required</mat-error>
                        </div>
              </mat-radio-group>    
              </div>
          <div class="row"  style="justify-content: center;">
          <mat-form-field  class="mat-form-field-50" appearance="outline">
            <mat-label>Email Address</mat-label>
            <input required matInput formControlName="email" placeholder="Email Address"
                   >
          </mat-form-field>
          <div *ngIf="this.hotelMotel.get('email')?.errors?.['required'] && (hotelMotel.get('email')?.touched)">
            <mat-error>Email Address is required</mat-error>
          </div>
          <div *ngIf="this.hotelMotel.get('email')?.errors?.['email'] && (hotelMotel.get('email')?.touched && hotelMotel.get('email')?.value)">
            <mat-error>Email Address is Invalid</mat-error>
          </div> 
          </div>
          <div class="row"  style="justify-content: center;">
          <mat-form-field  class="mat-form-field-50" appearance="outline" >
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder=" Phone Number"
                   >
          </mat-form-field>
  
          <div *ngIf="this.hotelMotel.get('phoneNumber')?.errors?.['required'] && (hotelMotel.get('phoneNumber')?.touched)">
            <mat-error>Phone Number is required</mat-error>
          </div>
  
          <div *ngIf="this.hotelMotel.get('phoneNumber')?.errors?.['pattern'] && (hotelMotel.get('phoneNumber')?.touched && hotelMotel.get('phoneNumber')?.value)">
            <mat-error>Phone Number is Invalid</mat-error>
          </div>
        </div> 
        <div class="row"  style="justify-content: center;">
          <mat-form-field class="mat-form-field-50" appearance="outline">
            <mat-label>Primary Contact First Name</mat-label>
            <input matInput formControlName="primaryContactFirstName" placeholder="Primary Contact First Name"
                   required>
                  </mat-form-field>
                  <div *ngIf="this.hotelMotel.get('primaryContactFirstName')?.errors?.['required'] && (hotelMotel.get('primaryContactFirstName')?.touched)">
                    <mat-error>Primary Contact First Name is required</mat-error>
                  </div>
                 
                </div>    
          <mat-form-field class="mat-form-field-50" appearance="outline" >
            <mat-label>Primary Contact Last Name</mat-label>
            <input matInput formControlName="primaryContactLastName" placeholder="Primary Contact Last Name"
                   >
          </mat-form-field>
          <div *ngIf="this.hotelMotel.get('primaryContactLastName')?.errors?.['required'] && (hotelMotel.get('primaryContactLastName')?.touched)">
            <mat-error>Primary Contact Last Name is required</mat-error>
          </div>
      
          
          <footer class="footer-step">
            <div  class="row" style="width: 59%;">
  
              <div style="width: 100%;
              padding-top: 16px;
              padding-bottom: 16px;
              box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
               <button mat-stroked-button mat-button class="button-cancel">
                CANCEL
                <mat-icon>close</mat-icon>
             </button>
             <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
              BACK
              <mat-icon>arrow_left_alt</mat-icon>
           </button>
             <button [disabled]="!hotelMotel.valid" matStepperNext mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': hotelMotel.valid ,'button-stepper': hotelMotel.invalid  }">
              NEXT
              <mat-icon>arrow_right_alt</mat-icon>
              
           </button>
            </div>
           </div>
          </footer>
        </div>
        </form>
      </mat-step>
    
      <mat-step style="justify-content: center;" [stepControl]="getFormGroupAddress()"  label="Owner">
     
          <div class="row" style="justify-content: center; margin-top: 46px;">

            <div *ngIf="!stepCompleted">
            <ng-template matStepLabel>Address</ng-template>
            <div *ngIf="registerAs === '1'" class="row" style="justify-content: center;">
              <label class="label-icon">
                <mat-icon>person</mat-icon>
                <span>INDIVIDUAL PROPERTY OWNER</span>
            </label>
              <br />
             
            </div>
            <div *ngIf="registerAs === '2'" class="row" style="justify-content: center;">
              <label class="label-icon">
                <mat-icon>business</mat-icon>
                <span>PROPERTY MANAGEMENT COMPANY</span>
            </label>
              <br />
             
            </div>
      
            <div *ngIf="registerAs === '3'" class="row" style="justify-content: center;">
              <label class="label-icon">
                <mat-icon>Home</mat-icon>
                <span>BED & BREAKFAST/ HOTEL / MOTEL</span>
            </label>
              <br />
             
            </div>
          </div>
            <div class="row" style="justify-content: center;margin-top: 24px; padding-bottom: 24px;">
              <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Address</div>
            </div>
            
            <div class="row" *ngIf="registerAs === '1'"  style="justify-content: center;">
            <mat-radio-group  aria-label="Select an option">
              <mat-radio-button [checked]="true" color="primary"  (change)="radioChangeAddress($event)"  value="1">Domestic</mat-radio-button>
              <mat-radio-button color="primary" (change)="radioChangeAddress($event)"  value="2">International</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="row" *ngIf="registerAs == '2' || registerAs== '3'"  style="justify-content: center;">
            <mat-radio-group  aria-label="Select an option">
              <mat-radio-button color="primary"[checked]="true"  (change)="radioChangeAddress($event)"  value="3">Domestic</mat-radio-button>
              <mat-radio-button color="primary" (change)="radioChangeAddress($event)"  value="4">International</mat-radio-button>
            </mat-radio-group>
          </div>
            <form *ngIf="registerAs == '1' && registerAsAddress == '1'" [formGroup]="addressOwner">
              <div class="row" style="justify-content: center;">
                 
                  <div style=" max-width: 600px;">
              <br />
              <div class="row">
                <div class="column">
                  <mat-form-field  class="mat-form-field-100" appearance="outline" >
                    <mat-label>Owners Street Address</mat-label>
                    <input class="form-outline form-control" matInput formControlName="address1" placeholder="Owners Street Address"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressOwner.get('address1')?.errors?.['required'] && (addressOwner.get('address1')?.touched)">
                    <mat-error>Owners Street Address is required</mat-error>
                  </div>
      
           
                </div>
      </div>
      <div class="row">
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Apt/Unit/Suite</mat-label>
                    <input matInput formControlName="address2" placeholder="Apt/Unit/Suite"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressOwner.get('address2')?.errors?.['required'] && (addressOwner.get('address2')?.touched)">
                    <mat-error>Apt/Unit/Suite is required</mat-error>
                  </div>
                </div>
              </div>
                <div class="row">
                  <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city" placeholder="City"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressOwner.get('city')?.errors?.['required'] && (addressOwner.get('city')?.touched)">
                    <mat-error>City is required</mat-error>
                  </div>
                </div>
      
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>State</mat-label>
      
                           <mat-select formControlName="state"  placeholder="State">
                          
                            @for (state of states; track state) {
                              <mat-option [value]="state.id">{{state.name}}</mat-option>
                            }
                          </mat-select>
                  </mat-form-field>
                  <div *ngIf="this.addressOwner.get('state')?.errors?.['required'] && (addressOwner.get('state')?.touched)">
                    <mat-error>State is required</mat-error>
                  </div>
                </div>
      
      
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Zip Code</mat-label>
                    <input matInput formControlName="zipCode" placeholder="Zip Code"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressOwner.get('zipCode')?.errors?.['pattern'] && (addressOwner.get('zipCode')?.touched)">
                    <mat-error>Zip Code is Invalid</mat-error>
       
                </div>
                 
                </div>
              </div>
              <div class="row">
                <div class="column">
                <mat-form-field class="mat-form-field-100" appearance="outline" >
                  <mat-label>Note</mat-label>
                  <textarea matInput formControlName="note" placeholder="Note"
                         ></textarea>
                </mat-form-field>
              </div>
              </div>
            
              </div></div>
              <footer class="footer-step">
                <div style="width: 30%; justify-content: space-around;">
         
                  <div style="width: 100%;
                  padding-top: 16px;
                  padding-bottom: 16px;
                  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                    <button  mat-stroked-button mat-button class="button-cancel">
                    CANCEL
                    <mat-icon>close</mat-icon>
                 </button>
                 <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
                  BACK
                  <mat-icon>arrow_left_alt</mat-icon>
               </button>
                 <button [disabled]="!addressOwner.valid" (click)="save()"  mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': addressOwner.valid ,'button-stepper': addressOwner.invalid  }">
                  SAVE AND REGISTER
                  <mat-icon>arrow_right_alt</mat-icon>
                  
               </button>
                </div>
               </div>
               </footer>
            </form>
            <form *ngIf="registerAsAddress == '2'|| registerAsAddress == '4' " [formGroup]="addressOwnerInternational">
       
                <div class="row" style="justify-content: center;max-width: 600px;">
                 
         
              <div class="row">
                <div class="column">
                <mat-form-field class="mat-form-field-100" appearance="outline" >
                  <mat-label>Addressee's Full Legal name</mat-label>
                  <input matInput formControlName="internationalAddressName" placeholder="Addressee's Full Legal name"
                         >
                </mat-form-field>
      
            <div *ngIf="this.addressOwnerInternational.get('internationalAddressName')?.errors?.['required'] && (addressOwnerInternational.get('internationalAddressName')?.touched)">
              <mat-error>Addressee's Full Legal name is required</mat-error>
            </div>
              </div>  
            </div>  
            <div class="row">
              <div class="column">
                <mat-form-field  class="mat-form-field-100" appearance="outline" >
                  <mat-label>Street Address or Post Office Box Number</mat-label>
                  <input matInput formControlName="internationalPoBox" placeholder="Street Address or Post Office Box Number"
                         >
                </mat-form-field>
                <div *ngIf="this.addressOwnerInternational.get('internationalPoBox')?.errors?.['required'] && (addressOwnerInternational.get('internationalPoBox')?.touched)">
                  <mat-error>Street Address or Post Office Box Number is required</mat-error>
                </div>
              </div>  
            </div>
            <div class="row">
              <div class="column">
                <mat-form-field  class="mat-form-field-100"  appearance="outline" >
                  <mat-label>City, Province, State</mat-label>
                  <input matInput formControlName="internationalCityProvinceState" placeholder="City, Province, State"
                         >
                </mat-form-field>
                <div *ngIf="this.addressOwnerInternational.get('internationalCityProvinceState')?.errors?.['required'] && (addressOwnerInternational.get('internationalCityProvinceState')?.touched)">
                  <mat-error>City, Province, State is required</mat-error>
                </div>
              </div>  
            </div>
            <div class="row">
              <div class="column">
      
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Country</mat-label>
      
                           <mat-select formControlName="internationalCountry"  placeholder="Country">
                          
                            @for (state of country; track state) {
                              <mat-option [value]="state.id">{{state.name}}</mat-option>
                            }
                          </mat-select>
                  </mat-form-field>
                  <div *ngIf="this.addressOwnerInternational.get('internationalCountry')?.errors?.['required'] && (addressOwnerInternational.get('internationalCountry')?.touched)">
                    <mat-error>Country required</mat-error>
                  </div>
                </div>
            </div>
                <div class="row">
                  <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Note</mat-label>
                    <textarea matInput formControlName="note" placeholder="Note"
                           ></textarea>
                  </mat-form-field>
                </div>
                </div>
                <footer class="footer-step">
                   
                  <div style="width: 100%; justify-content: space-around;">
              
                   <div style="width: 100%;
                   padding-top: 16px;
                   padding-bottom: 16px;
                   box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border-top: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                    <button mat-stroked-button mat-button class="button-cancel">
                                 CANCEL
                                 <mat-icon>close</mat-icon>
                              </button>
                              <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
                               BACK
                               <mat-icon>arrow_left_alt</mat-icon>
                            </button>
                              <button [disabled]="!addressOwnerInternational.valid" (click)="save()"  mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': addressOwnerInternational.valid ,'button-stepper': addressOwnerInternational.invalid  }">
                               SAVE AND REGISTER
                               <mat-icon>arrow_right_alt</mat-icon>
                               
                            </button>
                             </div>
                            </div>
                           </footer>
                </div>
             
            </form>
            <form *ngIf="(registerAs == '2' || registerAs == '3') && registerAsAddress == '3'" [formGroup]="addressProperty">
              <br />
              <div class="row">
                <div class="column">
                  <mat-form-field  class="mat-form-field-100" appearance="outline" >
                    <mat-label>Property management street Address</mat-label>
                    <input class="form-outline form-control" matInput formControlName="address1" placeholder="Owners Street Address"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressProperty.get('address1')?.errors?.['required'] && (addressProperty.get('address1')?.touched)">
                    <mat-error>Owners Street Address is required</mat-error>
                  </div>
      
           
                </div>
      </div>
      <div class="row">
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Apt/Unit/Suite</mat-label>
                    <input matInput formControlName="address2" placeholder="Apt/Unit/Suite"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressProperty.get('address2')?.errors?.['required'] && (addressProperty.get('address2')?.touched)">
                    <mat-error>Apt/Unit/Suite is required</mat-error>
                  </div>
                </div>
              </div>
                <div class="row">
                  <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city" placeholder="City"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressProperty.get('city')?.errors?.['required'] && (addressProperty.get('city')?.touched)">
                    <mat-error>City is required</mat-error>
                  </div>
                </div>
      
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>State</mat-label>
      
                           <mat-select formControlName="state"  placeholder="State">
                          
                            @for (state of states; track state) {
                              <mat-option [value]="state.id">{{state.name}}</mat-option>
                            }
                          </mat-select>
                  </mat-form-field>
                  <div *ngIf="this.addressProperty.get('state')?.errors?.['required'] && (addressProperty.get('state')?.touched)">
                    <mat-error>State is required</mat-error>
                  </div>
                </div>
      
      
                <div class="column">
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Zip Code</mat-label>
                    <input matInput formControlName="zipCode" placeholder="Zip Code"
                           >
                  </mat-form-field>
                  <div *ngIf="this.addressProperty.get('zipCode')?.errors?.['pattern'] && (addressProperty.get('zipCode')?.touched)">
                    <mat-error>Zip Code is Invalid</mat-error>
       
                </div>
                 
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <mat-form-field  class="mat-form-field-100" appearance="outline" >
                    <mat-label>Website url</mat-label>
                    <input class="form-outline form-control" matInput formControlName="address1" placeholder="Website url"
                           >
                  </mat-form-field>
             
      
           
                </div>
      </div>
              <div class="row">
                <div class="column">
                <mat-form-field class="mat-form-field-100" appearance="outline" >
                  <mat-label>Note</mat-label>
                  <textarea matInput formControlName="note" placeholder="Note"
                         ></textarea>
                </mat-form-field>
              </div>
              </div>
              <footer class="footer-step">
                <div  class="row">
      
                  <div style="width: 70%; padding-top: 16px;
                  padding-bottom: 16px;box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20); border: 1px #BDBDBD solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                 <button mat-stroked-button mat-button class="button-cancel">
                    CANCEL
                    <mat-icon>close</mat-icon>
                 </button>
                 <button mat-stroked-button mat-button matStepperPrevious class="button-stepper-allow">
                  BACK
                  <mat-icon>arrow_left_alt</mat-icon>
               </button>
                 <button [disabled]="!addressOwner.valid" (click)="save()" mat-stroked-button mat-button [ngClass]="{'button-stepper-allow': addressOwner.valid ,'button-stepper': addressOwner.invalid  }">
                  SAVE AND REGISTER
                  <mat-icon>arrow_right_alt</mat-icon>
                  
               </button>
                </div>
               </div>
              </footer>
            </form>
          </div>
          <div *ngIf="stepCompleted"  class="row">
            <div class="Frame62" style="width: 1376px; height: 319px; padding-top: 56px; padding-bottom: 56px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
              <div class="Frame63" style="align-self: stretch; height: 106px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 24px; display: flex">
                <div class="CheckCircle" style="width: 56px; height: 56px; position: relative">
     
                  <mat-icon style="color :#2E7D32 " color="#2E7D32">check_circle_outline</mat-icon>
         
    
                </div>
                <div class="Frame32" style="align-self: stretch; height: 26px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 8px; display: flex">
                  <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                    <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Form submitted succesfully!</div>
                  </div>
                </div>
              </div>
              <div class="Frame33" style="height: 69px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 8px; display: flex">
                <div class="Formlabel" style="height: 69px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                  <div class="Label" style="align-self: stretch; text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 22.88px; letter-spacing: 0.17px; word-wrap: break-word">Your information has been submitted and is now being reviewed. We'll get back to you within 72 hours. Sit tight and we'll be in touch soon!<br/></div>
                </div>
              </div>
            </div>
          </div>
      
     
       
      </mat-step>
    </mat-stepper>
   
   </div>

 